"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cssinjs = require("@ant-design/cssinjs");
var _colorBlock = require("./color-block");
var genSliderStyle = function genSliderStyle(token) {
  var componentCls = token.componentCls,
    colorPickerInsetShadow = token.colorPickerInsetShadow,
    colorBgElevated = token.colorBgElevated,
    colorFillSecondary = token.colorFillSecondary,
    lineWidthBold = token.lineWidthBold,
    colorPickerHandlerSizeSM = token.colorPickerHandlerSizeSM,
    colorPickerSliderHeight = token.colorPickerSliderHeight,
    marginSM = token.marginSM,
    marginXS = token.marginXS;
  var handleInnerSize = token.calc(colorPickerHandlerSizeSM).sub(token.calc(lineWidthBold).mul(2).equal()).equal();
  var handleHoverSize = token.calc(colorPickerHandlerSizeSM).add(token.calc(lineWidthBold).mul(2).equal()).equal();
  var activeHandleStyle = {
    '&:after': {
      transform: 'scale(1)',
      boxShadow: "".concat(colorPickerInsetShadow, ", 0 0 0 1px ").concat(token.colorPrimaryActive)
    }
  };
  return _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-slider"), [(0, _colorBlock.getTransBg)((0, _cssinjs.unit)(colorPickerSliderHeight), token.colorFillSecondary), _defineProperty({
    margin: 0,
    padding: 0,
    height: colorPickerSliderHeight,
    borderRadius: token.calc(colorPickerSliderHeight).div(2).equal(),
    '&-rail': {
      height: colorPickerSliderHeight,
      borderRadius: token.calc(colorPickerSliderHeight).div(2).equal(),
      boxShadow: colorPickerInsetShadow
    }
  }, "& ".concat(componentCls, "-slider-handle"), {
    width: handleInnerSize,
    height: handleInnerSize,
    top: 0,
    borderRadius: '100%',
    '&:before': {
      display: 'block',
      position: 'absolute',
      background: 'transparent',
      left: {
        _skip_check_: true,
        value: '50%'
      },
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: handleHoverSize,
      height: handleHoverSize,
      borderRadius: '100%'
    },
    '&:after': {
      width: colorPickerHandlerSizeSM,
      height: colorPickerHandlerSizeSM,
      border: "".concat((0, _cssinjs.unit)(lineWidthBold), " solid ").concat(colorBgElevated),
      boxShadow: "".concat(colorPickerInsetShadow, ", 0 0 0 1px ").concat(colorFillSecondary),
      outline: 'none',
      insetInlineStart: token.calc(lineWidthBold).mul(-1).equal(),
      top: token.calc(lineWidthBold).mul(-1).equal(),
      background: 'transparent',
      transition: 'none'
    },
    '&:focus': activeHandleStyle
  })]), "".concat(componentCls, "-slider-container"), _defineProperty({
    display: 'flex',
    gap: marginSM,
    marginBottom: marginSM
  }, "".concat(componentCls, "-slider-group"), {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    display: 'flex',
    '&-disabled-alpha': {
      justifyContent: 'center'
    }
  })), "".concat(componentCls, "-gradient-slider"), _defineProperty({
    marginBottom: marginXS
  }, "& ".concat(componentCls, "-slider-handle"), {
    '&:after': {
      transform: 'scale(0.8)'
    },
    '&-active, &:focus': activeHandleStyle
  }));
};
var _default = exports["default"] = genSliderStyle;